import { Message } from '@byted/serial-components-i18n';
import { LangCode } from '@common/lang';
import ArrowBtn from '@components/arrow-btn';
import { getDownloadUrl } from '@containers/home/setting';
import { useTranslation } from '@ies/intl-react-plugin';
import classNames from 'classnames';
import React from 'react';

import './index.less';

const HomeApp: React.FC = () => {
    const { i18n } = useTranslation();

    const lang = i18n.language as LangCode;

    const downLoadUrl = getDownloadUrl(lang);
    return (
        <section className={classNames('home-app', { [lang]: lang !== undefined })}>
            <h1>{i18n.t('web_download')}</h1>
            <div className="home-app-img" />
            <p>{i18n.t('web_download_note')}</p>
            <div className="app-btn-grow">
                <ArrowBtn
                    icon="apple"
                    text={i18n.t('pc_download_appstore')}
                    onClick={() => {
                        const ua = navigator.userAgent;
                        if (/android/i.test(ua)) {
                            Message.error(i18n.t('appstore_note'));
                        } else {
                            window.location.href = downLoadUrl.Ios;
                        }
                    }}
                />
                <ArrowBtn
                    icon="google"
                    text={i18n.t('pc_download_googleplay')}
                    onClick={() => {
                        window.location.href = downLoadUrl.Android;
                    }}
                />
            </div>
        </section>
    );
};
export default HomeApp;
